import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmDialogAttachmentComponent } from './confirm-dialog-attachment.component';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ReactiveFormsModule } from '@angular/forms';
import { RowFileUploadModule } from '../row-file-upload/row-file-upload.module';
import { FileCardModule } from '../file-card/file-card.module';



@NgModule({
  declarations: [
    ConfirmDialogAttachmentComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    MatIconModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    RowFileUploadModule,
    FileCardModule
  ]
})
export class ConfirmDialogAttachmentModule { }
